<div id="head"></div>
<h1 class="sr-only">{{ BRAND.name }} Brand Resources: Logos, Colors, Wallpapers &amp; Badges</h1>

<div class="pl-page">

  <!-- The Apps & Plugins hero band (owner 2026-10-12): the title, one line and a chip per box that jumps to it -->
  <header class="pl-hero">
    <div class="pl-hero-inner">
      <p class="tools-title" aria-hidden="true">Brand Resources</p>
      <p class="tools-subtitle">Logos, colors, wallpapers and badges, with the rules that keep {{ BRAND.name }} recognisable</p>
      <nav class="pl-chips" aria-label="Brand resource sections">
        <a *ngFor="let s of pageSections" class="pl-chip" [attr.href]="'#sec-' + s.key" (click)="jumpTo( s.key, $event )">
          <span>{{ s.label }}</span>
        </a>
      </nav>
    </div>
  </header>

  <!-- every resource as the home's box (owner 2026-10-12, redone from scratch): the words at the left, what they
       are about on a stage at the right -->
  <div class="bx-list">

    <!-- Guidelines -->
    <section class="bx" id="sec-guidelines" tabindex="-1">
      <div class="bx-copy">
        <span class="bx-eyebrow"><img class="bx-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="18" height="18"/>Usage</span>
        <h2 class="bx-title">Guidelines</h2>
        <p class="bx-lead">Use the {{ BRAND.name }} marks the same way everywhere</p>
        <p class="bx-text">
          {{ BRAND.name }}, its name and its logo are protected by trademark, copyright and other intellectual
          property laws, and any use of them follows the {{ BRAND.name }} Trademark Standards. Write to us with any
          question or to ask approval for a use at
          <a class="bx-mail" [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>
        </p>
      </div>
      <ol class="bx-stage bx-rules">
        <li *ngFor="let rule of rules; index as i" class="bx-rule">
          <span class="bx-rule-index">{{ i + 1 }}</span>
          <span class="bx-rule-text">{{ rule }}</span>
        </li>
      </ol>
    </section>

    <!-- Colors -->
    <section class="bx" id="sec-colors" tabindex="-1">
      <div class="bx-copy">
        <span class="bx-eyebrow"><img class="bx-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="18" height="18"/>Palette</span>
        <h2 class="bx-title">Colors</h2>
        <p class="bx-lead">The canonical brand palette</p>
        <p class="bx-text">
          The blue leads, the cyan lights it up and the black holds them. Open a color to see its shades, schemes and
          every format of it.
        </p>
      </div>
      <div class="bx-stage bx-swatches">
        <a *ngFor="let c of colors" class="bx-swatch" [routerLink]="URLS.tools.color + '/' + c.hex.substring( 1 )">
          <span class="bx-swatch-chip" [style.background]="c.hex"></span>
          <span class="bx-swatch-name">{{ c.name }}</span>
          <span class="bx-swatch-hex">{{ c.hex | lowercase }}</span>
        </a>
      </div>
    </section>

    <!-- Logo -->
    <section class="bx" id="sec-logo" tabindex="-1">
      <div class="bx-copy">
        <span class="bx-eyebrow"><img class="bx-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="18" height="18"/>Primary Mark</span>
        <h2 class="bx-title">Logo</h2>
        <p class="bx-lead">The {{ BRAND.name }} mark in full resolution</p>
        <p class="bx-text">
          Keep it upright, in its own colors and in proportion, with clear space round it at least as wide as its
          x-height, and no smaller than 100px.
        </p>
        <div class="bx-actions">
          <a class="codigrate-button" [href]="raw( BRAND.logo.main )" download><p>Download PNG</p></a>
        </div>
      </div>
      <div class="bx-stage bx-plates bx-plates-one">
        <div class="bx-plate">
          <img [src]="BRAND.logo.main" alt="{{ BRAND.name }} logo" class="bx-logo" loading="lazy" decoding="async"/>
        </div>
      </div>
    </section>

    <!-- Inline Logos -->
    <section class="bx" id="sec-inline" tabindex="-1">
      <div class="bx-copy">
        <span class="bx-eyebrow"><img class="bx-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="18" height="18"/>Lockups</span>
        <h2 class="bx-title">Inline Logos</h2>
        <p class="bx-lead">The mark and the name on one line</p>
        <p class="bx-text">The light lockup for light grounds, the dark one for dark grounds.</p>
        <div class="bx-actions">
          <a class="codigrate-button" [href]="raw( BRAND.logo.inlineLight )" download><p>Light PNG</p></a>
          <a class="codigrate-button" [href]="raw( BRAND.logo.inlineDark )" download><p>Dark PNG</p></a>
        </div>
      </div>
      <div class="bx-stage bx-plates">
        <div class="bx-plate bx-plate-light">
          <img [src]="BRAND.logo.inlineLight" alt="{{ BRAND.name }} inline logo, light" class="bx-inline" loading="lazy" decoding="async"/>
        </div>
        <div class="bx-plate bx-plate-dark">
          <img [src]="BRAND.logo.inlineDark" alt="{{ BRAND.name }} inline logo, dark" class="bx-inline" loading="lazy" decoding="async"/>
        </div>
      </div>
    </section>

    <!-- Wallpapers -->
    <section class="bx" id="sec-wallpapers" tabindex="-1">
      <div class="bx-copy">
        <span class="bx-eyebrow"><img class="bx-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="18" height="18"/>Desktop</span>
        <h2 class="bx-title">Wallpapers</h2>
        <p class="bx-lead">Desktop wallpapers in the {{ BRAND.name }} style</p>
        <p class="bx-text">Blue, light and dark, and a dynamic one that follows your Mac from day to night. Click one to download it.</p>
      </div>
      <div class="bx-stage bx-shots bx-shots-desktop">
        <a *ngFor="let w of wallpapers" class="bx-shot" [href]="w.asset.raw" download [title]="'Download ' + w.name">
          <img [src]="w.asset.min" [alt]="w.name" loading="lazy" decoding="async"/>
          <span class="bx-shot-name">{{ w.name }}</span>
        </a>
      </div>
    </section>

    <!-- Mobile Wallpapers -->
    <section class="bx" id="sec-mobile" tabindex="-1">
      <div class="bx-copy">
        <span class="bx-eyebrow"><img class="bx-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="18" height="18"/>Phone</span>
        <h2 class="bx-title">Mobile Wallpapers</h2>
        <p class="bx-lead">Sized for portrait screens</p>
        <p class="bx-text">The same three looks for your phone. Click one to download it.</p>
      </div>
      <div class="bx-stage bx-shots bx-shots-phone">
        <a *ngFor="let w of mobileWallpapers" class="bx-shot" [href]="w.asset.raw" download [title]="'Download ' + w.name">
          <img [src]="w.asset.min" [alt]="w.name" loading="lazy" decoding="async"/>
          <span class="bx-shot-name">{{ w.name }}</span>
        </a>
      </div>
    </section>

    <!-- Badges -->
    <section class="bx" id="sec-badges" tabindex="-1">
      <div class="bx-copy">
        <span class="bx-eyebrow"><img class="bx-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="18" height="18"/>Link Back</span>
        <h2 class="bx-title">Badges</h2>
        <p class="bx-lead">Show you work with {{ BRAND.name }}</p>
        <p class="bx-text">Ready made badges for light and dark pages, to link back to us.</p>
        <div class="bx-actions">
          <a *ngFor="let b of badges" class="codigrate-button" [href]="b.asset.raw" download><p>{{ b.label }} PNG</p></a>
        </div>
      </div>
      <div class="bx-stage bx-plates">
        <div *ngFor="let b of badges" class="bx-plate" [class.bx-plate-light]="b.label === 'Light'" [class.bx-plate-dark]="b.label === 'Dark'">
          <img [src]="b.asset.min" [alt]="b.name" class="bx-badge" loading="lazy" decoding="async"/>
        </div>
      </div>
    </section>

  </div>
</div>
